import { put, select, take, takeLatest } from 'redux-saga/effects';
import { RootAction } from 'store/state';
import { SET_MUTATION_RESPONSE } from 'store/state/mutationsResponse/types';
import { MutationType } from './apiService/types';
import { newListingAction, createListingAndPayForPlanAction } from 'store/state/uploadBulletin/actions';
import { initiatePayment, redeemPromotionPlanGrant, setToastMessage } from 'store/state/app/actions';
import { newListingResponseSelector } from 'store/state/mutationsResponse/selectors';
import * as Types from 'store/state/uploadBulletin/types';

const newListingMutationPattern = (action: RootAction) =>
  action.type === SET_MUTATION_RESPONSE && action.mutationType === MutationType.NewListing;

/**
 * Wizard-only flow: create listing then initiate payment for the selected plan via iframe.
 */
function* createListingAndPayForPlanWorker(action: ReturnType<typeof createListingAndPayForPlanAction>) {
  const { listing, plan, redirectUrl, initiateSource } = action.payload;
  const isGrantPlan = plan.isUserEligibleForGrant;
  const source = isGrantPlan ? 'wizardGrantPlan' : 'wizardPaidPlanViaIframe';

  yield put(newListingAction({ listing, source }));
  yield take(newListingMutationPattern);

  const response: ReturnType<typeof newListingResponseSelector> = yield select(newListingResponseSelector);
  const newListing = response && response.data && response.data.newListing && response.data.newListing.listing;

  if (newListing && newListing.id) {
    if (isGrantPlan) {
      yield put(redeemPromotionPlanGrant({ planId: plan.id }));
      return;
    }

    yield put(initiatePayment({
      productId: plan.id,
      redirectUrl,
      initiateSource,
      bulletinsId: newListing.id,
    }));
  }
  else {
    yield put(setToastMessage({ type: 'error', term: 'error.promotionPlan.requiresBulletinId', autoHideTimeout: 10000 }));
  }
}

export function* createListingAndPayForPlanSaga() {
  yield takeLatest(Types.CREATE_LISTING_AND_PAY_FOR_PLAN, createListingAndPayForPlanWorker);
}
